import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, ref } from "vue";

import { apiClient } from "@/plugins/api-client";
import { checkIsRouteAuthorized } from "@/security/authorization";
import type { OntologyResponse } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'OntologyListView',
  setup(__props) {

const $dayjs = inject("$dayjs");

const ontologies = ref<Array<OntologyResponse>>([]);

const fetchOntologies = async () => {
  ontologies.value = await apiClient.ontologies.listOntologies();
};

const filterTag = ref<string[]>([]);
const tags = computed<string[]>((): string[] => {
  return [...new Set(ontologies.value.map((ontology) => ontology.tags).flat())];
});

const query = ref<string | undefined>(undefined);

const visibleOntologies = computed(() => {
  let items = ontologies.value
    .filter(
      ({ tags }) =>
        filterTag.value.length === 0 ||
        filterTag.value.every((tag) => tags.includes(tag))
    )
    .filter(
      ({ name, description, tags }) =>
        !query.value ||
        query.value?.length < 3 ||
        tags.some(
          (tag) =>
            !query.value ||
            tag.toLowerCase().includes(query.value.toLowerCase())
        ) ||
        name.toLowerCase().includes(query.value.toLowerCase()) ||
        description.toLowerCase().includes(query.value.toLowerCase())
    );
  items.sort((a, b) =>
    a.updated_at < b.updated_at ? 1 : a.updated_at > b.updated_at ? -1 : 0
  );
  return items;
});

const highlightText = (text: string) => {
  const pattern = new RegExp(`(${query.value?.toLowerCase()})`, "gi");
  return text.replace(pattern, "<span class='highlight'>$1</span>");
};

onMounted(async () => {
  fetchOntologies();
});

return { __sfc: true,$dayjs, ontologies, fetchOntologies, filterTag, tags, query, visibleOntologies, highlightText, checkIsRouteAuthorized }
}

})